var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#90DCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 21.0013C8.5 19.1605 9.9925 17.668 11.8333 17.668H15.1667C17.0075 17.668 18.5 19.1605 18.5 21.0013",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.334 9.87695C20.4848 9.87695 21.4173 10.8095 21.4173 11.9603C21.4173 13.1111 20.4848 14.0436 19.334 14.0436",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5042 10.1641C16.611 11.2709 16.611 13.0654 15.5042 14.1722C14.3974 15.279 12.6029 15.279 11.4961 14.1722C10.3893 13.0654 10.3893 11.2709 11.4961 10.1641C12.6029 9.05728 14.3974 9.05728 15.5042 10.1641",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.166 16.834C22.0068 16.834 23.4993 18.3265 23.4993 20.1673",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendIcon);
export default __webpack_public_path__ + "static/media/AttendIcon.1c3dbb936034c4be9975dee2406f83c2.svg";
export { ForwardRef as ReactComponent };